const PRODUCTION_WEBSITE_HOSTS = new Set(["constructorfleet.com", "www.constructorfleet.com"]);

function inferApiBaseUrlFromLocation() {
  const hostname = globalThis.location?.hostname?.trim().toLowerCase() ?? "";
  if (!PRODUCTION_WEBSITE_HOSTS.has(hostname)) {
    return "";
  }

  const protocol = globalThis.location?.protocol === "http:" ? "http:" : "https:";
  return `${protocol}//api.constructorfleet.com`;
}

export function getApiBaseUrl() {
  const env = import.meta as ImportMeta & { env?: { VITE_API_BASE_URL?: string } };
  return env.env?.VITE_API_BASE_URL?.trim() || inferApiBaseUrlFromLocation();
}

export function resolveApiUrl(path: string) {
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl || !path.startsWith("/api/")) {
    return path;
  }

  return new URL(path, apiBaseUrl).toString();
}
